import { CLAIMANT_GENDER_CHOICES } from "@/types";
import { SelectInput, SelectInputProps } from "react-admin";

export const GenderInput = (props: SelectInputProps) => (
  <SelectInput {...props} choices={CLAIMANT_GENDER_CHOICES} optionText="name" optionValue="id" fullWidth />
);
